import React from 'react';
import { Language } from '../../types';

interface Props {
  language: Language;
}

const translations = {
  [Language.EN]: {
    hubTitle: 'Le Sector Facilitated Platform',
    hubSubtitle: 'Private & Managed Introductions',
    homeowners: 'Homeowners',
    investors: 'Investors',
    developers: 'Developers',
    professionals: 'Industry Pros',
    privacyGuard: '100% Private • No Public Contact Sharing'
  },
  [Language.ZH]: {
    hubTitle: 'Le Sector 撮合与引荐平台',
    hubSubtitle: '私密与专业管理引荐',
    homeowners: '业主',
    investors: '投资者',
    developers: '开发商',
    professionals: '行业专业人士',
    privacyGuard: '100% 隐私保护 • 不公开联系方式'
  },
  [Language.VI]: {
    hubTitle: 'Nền tảng Giới thiệu Le Sector',
    hubSubtitle: 'Kết nối Riêng tư & Chuyên nghiệp',
    homeowners: 'Chủ nhà',
    investors: 'Nhà đầu tư',
    developers: 'Nhà phát triển',
    professionals: 'Chuyên gia Ngành',
    privacyGuard: 'Bảo mật 100% • Không công khai liên hệ'
  },
  [Language.HI]: {
    hubTitle: 'Le Sector सुगम मंच',
    hubSubtitle: 'निजी और प्रबंधित परिचय',
    homeowners: 'गृहस्वामी',
    investors: 'निवेशक',
    developers: 'डेवलपर्स',
    professionals: 'उद्योग विशेषज्ञ',
    privacyGuard: '100% गोपनीय • कोई सार्वजनिक संपर्क नहीं'
  }
};

export const ExploreOpportunitiesDiagram: React.FC<Props> = ({ language }) => {
  const t = translations[language] || translations[Language.EN];

  return (
    <div className="w-full flex flex-col my-4 space-y-3">
      {/* Ecosystem Hub Grid */}
      <div className="bg-slate-900 p-5 rounded-none border-l-4 border-blue-500 shadow-md text-white">
        <div className="flex items-center justify-between mb-3 border-b border-slate-800 pb-2">
          <div>
            <h4 className="text-xs uppercase tracking-widest font-bold text-white flex items-center gap-2">
              <i className="fa-solid fa-network-wired text-blue-400"></i>
              {t.hubTitle}
            </h4>
            <p className="text-[10px] text-slate-400 mt-0.5 tracking-wide">{t.hubSubtitle}</p>
          </div>
          <span className="text-[9px] uppercase tracking-wider bg-blue-500/20 text-blue-300 border border-blue-500/30 px-2 py-0.5 font-mono">
            Ecosystem
          </span>
        </div>

        {/* 4 Connected Nodes */}
        <div className="grid grid-cols-2 gap-2 mt-3">
          <div className="bg-slate-800/80 p-2.5 flex items-center space-x-2 border border-slate-700/60">
            <div className="w-6 h-6 rounded-none bg-blue-500/10 text-blue-400 flex items-center justify-center text-xs shrink-0">
              <i className="fa-solid fa-house"></i>
            </div>
            <span className="text-xs font-semibold text-slate-200">{t.homeowners}</span>
          </div>

          <div className="bg-slate-800/80 p-2.5 flex items-center space-x-2 border border-slate-700/60">
            <div className="w-6 h-6 rounded-none bg-emerald-500/10 text-emerald-400 flex items-center justify-center text-xs shrink-0">
              <i className="fa-solid fa-chart-line"></i>
            </div>
            <span className="text-xs font-semibold text-slate-200">{t.investors}</span>
          </div>

          <div className="bg-slate-800/80 p-2.5 flex items-center space-x-2 border border-slate-700/60">
            <div className="w-6 h-6 rounded-none bg-amber-500/10 text-amber-400 flex items-center justify-center text-xs shrink-0">
              <i className="fa-solid fa-city"></i>
            </div>
            <span className="text-xs font-semibold text-slate-200">{t.developers}</span>
          </div>

          <div className="bg-slate-800/80 p-2.5 flex items-center space-x-2 border border-slate-700/60">
            <div className="w-6 h-6 rounded-none bg-indigo-500/10 text-indigo-400 flex items-center justify-center text-xs shrink-0">
              <i className="fa-solid fa-user-gear"></i>
            </div>
            <span className="text-xs font-semibold text-slate-200">{t.professionals}</span>
          </div>
        </div>
      </div>

      {/* Security & Privacy Badge */}
      <div className="bg-slate-100 p-2.5 border-l-2 border-slate-400 flex items-center justify-between text-slate-700">
        <span className="text-[11px] font-medium flex items-center gap-2">
          <i className="fa-solid fa-shield-halved text-slate-500 text-xs"></i>
          {t.privacyGuard}
        </span>
        <i className="fa-solid fa-lock text-slate-400 text-xs"></i>
      </div>
    </div>
  );
};
